export interface Usuario{
    autorizado: number;
    crearproyecto: number;
    hindex: string;
    iddecinvuser: number;
    identificacion: string;
    idpersona: number;
    idunidad: number;
    nombreCompleto: string;
    orcid: string;
    rol: number;
    scholarid: string;
    scopusid:  string;
    usuario: string;
}

export interface OptionReactSelect{
    value: string;
    label: string;
}

export function getVoidOption():OptionReactSelect{
    return{
        value: '',
        label:''
    }
}

export function setUsuarioSearch(data: any): Usuario{    
    return{
        autorizado: data.autorizado?? 0,  
        crearproyecto: data.crearproyecto?? 0,
        hindex: data.hindex??"",
        iddecinvuser: data.iddecinvuser?? 0,
        identificacion: data.identificacion??"",
        idpersona: data.idpersona?? 0, 
        idunidad: data.cedula?? "",  
        nombreCompleto: data.nombre?? "",  
        orcid: data.email?? "", 
        rol: data.rol?? 0, 
        scholarid: data.scholarid?? "", 
        scopusid: data.scopusid?? "", 
        usuario: data.usuario??"", 
    }
}

export function setListUsuario(data: Array<any>): Array<Usuario>{
    let listUsuario: Array<Usuario> = [];
    data.forEach((item) => {
        const usuario: Usuario = setUsuarioSearch(item)
        listUsuario.push(usuario);
    });
    return listUsuario;
}

export function setUsuarioSelect(data: Array<any>): Array<OptionReactSelect>{
    let listUsuario: Array<OptionReactSelect> = [];
    data.forEach((item) => {
        const usuario: OptionReactSelect = {value: item.idpersona,label: item.nombreCompleto+' - '+item.email}
        listUsuario.push(usuario);
    });
    return listUsuario;
}

export function setUsuarioSelectUsuario(data: Array<any>): Array<OptionReactSelect>{
    let listUsuario: Array<OptionReactSelect> = [];
    data.forEach((item) => {
        const usuario: OptionReactSelect = {value: item.email,label: item.nombreCompleto+' - '+item.email}
        listUsuario.push(usuario);
    });
    return listUsuario;
}

export function setUsuarioSelectCedula(data: Array<any>): Array<OptionReactSelect>{
    let listUsuario: Array<OptionReactSelect> = [];
    data.forEach((item) => {
        const usuario: OptionReactSelect = {value: item.usuario,label: item.nombreCompleto+' - '+item.identificacion}
        listUsuario.push(usuario);
    });
    return listUsuario;
}
